import { render, staticRenderFns } from "./AreaSwitchPopup.vue?vue&type=template&id=09d72d60&scoped=true&"
import script from "./AreaSwitchPopup.vue?vue&type=script&lang=js&"
export * from "./AreaSwitchPopup.vue?vue&type=script&lang=js&"
import style0 from "./AreaSwitchPopup.vue?vue&type=style&index=0&id=09d72d60&prod&lang=scss&scoped=true&"
import style1 from "./AreaSwitchPopup.vue?vue&type=style&index=1&id=09d72d60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d72d60",
  null
  
)

export default component.exports